import { useMount } from 'shared/src/hooks';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';

export const useLogViewFindPassword = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  useMount(() => {
    logAnalyticsEvent({
      name: 'VIEW_FIND_PASSWORD',
      channel: ['firebase', 'amplitude', 'ablylog'],
    });
  });
};
